<div class="afterHours">
  <div class="closed">
    <span>Live chat is closed.</span>
  </div>
  <div class="hours">Chat Hours: <span>Mon - Fri, 9am - 8pm ET</span></div>
  <div class="return">Please return during chat hours.</div>
  <div class="answer">We'll be happy to answer your questions then.</div>
</div>
